import React, { useEffect, useState, useRef } from 'react'
import Box from '@mui/joy/Box'
import { NumberInput } from './ui/NumberInput'
import { debounce } from 'lodash'
import { GOOGLE_FONTS_API_KEY, RENDER_DEBOUNCE_MS } from '../consts'
import FormControl from '@mui/joy/FormControl'
import FormLabel from '@mui/joy/FormLabel'
import FontFaceObserver from 'fontfaceobserver'
import FontPicker from 'react-fontpicker-ts'
import { TextAlignGrid } from './TextAlignGrid'
import { FontSizeControl } from './FontSizeControl'

const FONT_LOAD_TIMEOUT_MS = 2000
export const TextGrid = ({
    onFontChange,
    onFontSizeChange,
    onTextChange,
    onWeightChange,
    onTextAlignChange,
    textObj,
    children,
}) => {
    useEffect(() => {
        textObj.on('changed', debounce(handleTextChange, RENDER_DEBOUNCE_MS))
        return () => {
            textObj.off('changed')
        }
    }, [textObj])

    // HACK: Moved to a better fontpicker, however, react-fontpicker-ts
    // doesn't support local fonts. Thus, fonts like Times New Roman
    // can't be loaded from the picker currently (i.e. they're not google fonts).
    // Since templates may have local fonts, we're setting a sane default.
    // There are other fonts that will need this hack, but we should
    // ultimately get them supported...please fix me.
    let defaultFont = textObj.fontFamily
    if (defaultFont === 'Times New Roman') {
        defaultFont = 'Tinos'
    }

    const [font, setFont] = useState(defaultFont)
    const [textAlign, setTextAlign] = useState(textObj.textAlign)
    const [weight, setWeight] = useState(100)

    const handleFontChange = (newValue) => {
        let selectedFont = new FontFaceObserver(newValue, {
            weight: weight,
        })
        selectedFont
            .load(null, FONT_LOAD_TIMEOUT_MS)
            .then(() => {
                console.log('successfully loaded font', newValue)
                setFont(newValue)
                onFontChange({ obj: textObj, value: newValue })
            })
            .catch((e) => {
                console.log(e)
                console.log('Error loading font', newValue)
            })
    }

    const handleTextChange = () => {
        onTextChange(textObj)
    }

    const handleFontSizeChange = (value) => {
        onFontSizeChange({ obj: textObj, value: value })
    }

    const handleWeightChange = (value) => {
        let selectedFont = new FontFaceObserver(font, {
            weight: value,
        })
        selectedFont
            .load(null, FONT_LOAD_TIMEOUT_MS)
            .then(() => {
                console.log('successfully loaded font', font)
                setWeight(value)
                onWeightChange({ obj: textObj, value: value })
            })
            .catch((e) => {
                console.log(e)
                console.log('Error loading weight for font', font)
            })
    }

    const handleAlignChange = (e) => {
        let value = e.target.value
        setTextAlign(value)
        onTextAlignChange({ obj: textObj, value: value })
    }

    return (
        <>
            <FormControl>
                <FormLabel>Font</FormLabel>
                <FontPicker
                    autoLoad
                    loadAllVariants
                    defaultValue={font}
                    value={(newFont) => handleFontChange(newFont)}
                    style={{ minWidth: 200 }}
                />
            </FormControl>
            <FontSizeControl
                textObj={textObj}
                onChange={handleFontSizeChange}
            />
            <NumberInput
                label="Weight"
                onChange={handleWeightChange}
                min={100}
                max={900}
                step={100}
                value={weight}
            />
            <Box>
                <TextAlignGrid
                    setting={textAlign}
                    onChange={handleAlignChange}
                />
            </Box>
            {children && <Box>{children}</Box>}
        </>
    )
}
